import React from "react";
import generateConfig from "../util/config";
import SignInComp from "../components/signIn/SignInComp";

const config = generateConfig();

export default function SignIn() {
  return <SignInComp />;
}

export async function getServerSideProps() {
  const metaTags = {
    title: `Sign in | ${config.siteName || ""} - Get in Touch with Us Today`,
    description: `Securely access personalized experiences and conversations with ${
      config.siteName || "Krushna Raut"
    }, an experienced full-stack developer.`,
    keywords:
      "Sign in, Krushna Raut login, portfolio account, experienced full-stack developer, Google OAuth",
    img: "/social-card.svg",
  };

  return {
    props: {
      metaTags,
    },
  };
}
